// extracted by mini-css-extract-plugin
export default {"card":"QazlK","card-main":"y02X1","card-secondary":"tVm_N","card-tertiary":"ryrxW","card-salary":"C5OOJ","card-benefit":"sqyWs"};